import Marquee from "react-fast-marquee";
import { FadeUp } from "./Reveal";
import { PRESS_ARTICLES } from "../../data/content";

const PressStrip = () => (
    <section className="bg-white py-10 md:py-12 border-b border-slate-100" data-testid="press-strip">
        <FadeUp>
            <p className="text-center text-[11px] font-semibold uppercase tracking-[0.35em] text-slate-400 mb-7">
                As featured in
            </p>
        </FadeUp>
        <Marquee speed={22} gradient={false} pauseOnHover>
            {[...PRESS_ARTICLES, ...PRESS_ARTICLES].map((a, i) => (
                <a
                    key={i}
                    href={a.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={i < PRESS_ARTICLES.length ? `press-strip-logo-${i + 1}` : undefined}
                    aria-label={a.outlet}
                    className="mx-10 md:mx-14 flex items-center opacity-60 hover:opacity-100 transition-opacity duration-300"
                >
                    <img
                        src={a.logo}
                        alt={a.outlet}
                        loading="lazy"
                        className={`w-auto object-contain ${
                            a.darkChip
                                ? "h-9 md:h-10 rounded-md bg-black px-2.5 py-1.5"
                                : "h-7 md:h-8 grayscale hover:grayscale-0 transition-[filter] duration-300"
                        }`}
                    />
                </a>
            ))}
        </Marquee>
    </section>
);

export default PressStrip;
